import React, { Component } from "react";
import { connect } from "react-redux";
import api from "../../config/api";
import { openSnackComp } from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import CardBankGroup from "../../components/CardBankGroup";
import { checkDebitsExist } from "../../helper/checkDebitsExist";
import { getBanks } from "../../helper/getBanks";
import { getIds } from "../../helper/getBarCode";
import Snackbar from "../../components/Snackbar";
import ContentNotLoaded from "../../components/ContentNotLoaded";
import LoadingDefault from "../../components/LoadingDefault";
import ModalMessage from "../../components/UserMessageHome";
import { convertDate } from "../../helper/convertDate";

const styles = (theme) => ({
  container: {
    padding: "0px 10px",
    marginTop: "130px",
  },
  gridItem: {
    padding: 15,
  },
  arrowLeft: {
    marginRight: 5,
    paddingTop: 3,
  },
  message: {
    width: "100%",
    fontSize: 18,
  },
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
});

export class PaymentBank extends Component {
  constructor(props) {
    super(props);
    this.handlePay = this.handlePay.bind(this);
  }
  state = {
    bankSelected: "",
    banks: [],
    loading: false,
    message: "",
    errorOnlinePayment: false,
    openModal: false,
    msgSnackbar: "",
    titleMessage: "",
    paymentDateValue: "",
  };

  componentWillMount() {
    checkDebitsExist(this.props);
  }

  componentDidMount() {
    this.getBank();
    this.getIdsDebits();
    this.props.setClick(this.handlePay);
  }

  getBank = () => {
    this.setState({
      loading: true,
    });

    let returnBanks = getBanks(1);
    returnBanks.then((response) => {
      this.setState({
        banks: response,
        loading: false,
      });
    });
  };

  getIdsDebits = () => {
    const ids = getIds(this.props.debitsSelectedValue);
    this.setState({ debitsIds: ids });
  };

  handlePay = async () => {
    let response = [];
    let Ids = getIds(this.props.debitsSelectedValue);
    const DataPagamentoDAM = this.props.paymentDateValue;
    try {
      let bodyRequest = {
        Ids: Ids,
        DataPagamento: DataPagamentoDAM,
        BancoId: this.props.bankSelectedOnlinePayment,
      };
      const barCodeResponse = await api.post(
        "Debitos/GerarBoletoOnline",
        bodyRequest
      );
      if (
        barCodeResponse.data.EhValida &&
        barCodeResponse.data.Retorno !== null &&
        barCodeResponse.data.Retorno !== undefined
      ) {
        response = barCodeResponse.data.Retorno;
        this.props.setOpenBankInfos({
          retorno: response,
          DataPagamentoDAM: DataPagamentoDAM,
        });
        this.redirectOnlinePayment();
      } else {
        this.setState({
          openModal: true,
          msgSnackbar: barCodeResponse.data.Erros[0],
        });
      }
    } catch (error) {
    }
  };

  redirectOnlinePayment = () => {
    this.setState({
      errorOnlinePayment: false,
    });

    if (this.state.bankSelected !== "") {
      if (
        this.props.debitsSelectedValue.length > 0 &&
        this.state.banks.length > 0
      ) {
        this.handleOpenBankGateway(
          this.props.openBankInfos.retorno,
          this.props.openBankInfos.retorno.DataPagamentoDAM
        );
        const from = { pathname: "/confirmacao-pagamento-credito" };
        this.props.history.push(from);
      } else {
        this.setState(
          {
            message: "Erro ao carregar os dados. Tente novamente mais tarde.",
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      }
    } else {
      this.setState(
        {
          message: "Você deve selecionar um banco para prosseguir.",
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    }
  };

  handleOpenBankGateway = async (barCode, paymentDate) => {
    let url = "";
    let shortDate = convertDate(paymentDate);
    switch (this.state.bankSelected) {
      case 1: {
        //Banco do Brasil S.A.

        const htmlPopUpBB = `<form method="post" target="popupBB" id="bbFormID" style="none" action="https://www2.bancobrasil.com.br/aapf/login.jsp">
          <input type="hidden" name="transacao" value="pagamento/892.jsp">
          <input type="hidden" name="codT" value="03">
          <input type="hidden" name="barraCampo1" value="${barCode.substring(
            0,
            12
          )}">
          <input type="hidden" name="barraCampo2" value="${barCode.substring(
            12,
            24
          )}">
          <input type="hidden" name="barraCampo3" value="${barCode.substring(
            24,
            36
          )}">
          <input type="hidden" name="barraCampo4" value="${barCode.substring(
            36,
            48
          )}">
          <input type="hidden" name="dataPagamento" value="${shortDate}">
        <script type="text/javascript">
            window.open('about:blank','popupBB','width=700,height=425')
            document.getElementById('bbFormID').submit();
        </script>`;

        const w = window.open("", "popupBB", "width=700,height=425");
        w.document.open();
        w.document.write(htmlPopUpBB);
        w.document.close();

        break;
      }
      case 4: {
        //Banco do Nordeste do Brasil S.A.

        return false;
      }
      case 28: {
        //BANEB S.A.

        return false;
      }
      case 104: {
        //Caixa Econômica Federal

        return false;
      }
      case 237: {
        //Bradesco S.A.
        url = `https://www.ib2.bradesco.com.br/ibpfgeral/siteaSiteInicio.jsf?CODBAR=${barCode}`;
        window.open(url, "sharer", "toolbar=0,status=0,width=700,height=425");

        break;
      }
      case 341: {
        //Itaú S.A.

        const htmlPopUpItau = `<form method="post" target="popupItau" id="itauFormID" style="display:none" action="https://ww27.itau.com.br/Concessionaria/ConcessionariaWebApp/Home.aspx">
            <input type="hidden" name="CodBar" value="${barCode}" />
            <input type="hidden" name="NRC" value="" />
          </form>
          <script type="text/javascript">
            window.open('about:blank','popupItau','width=700,height=425')
            document.getElementById('itauFormID').submit();
          </script>`;

        const w = window.open("", "popupItau", "width=700,height=425");
        w.document.open();
        w.document.write(htmlPopUpItau);
        w.document.close();

        break;
      }
      case 389: {
        //Mercantil do Brasil S.A.

        return false;

        //break
      }
      case 641: {
        //Bilbao Vizcaya Brasil S.A.

        return false;

        //break
      }
      case 33: {
        //Banco Santander Brasil S.A.
        url = `https://www.santandernet.com.br/default.asp?CODBARRAS=${barCode}`;
        window.open(url, "sharer", "toolbar=0,status=0,width=700,height=425");
        break;
      }
      default: {
        return false;
      }
    }
  };

  handleBankSelected = (item) => {
    this.setState({
      bankSelected: parseInt(item),
    });
    this.props.setBankSelectedOnlinePayment(parseInt(item));
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };
  render() {
    const { classes } = this.props;
    const { banks, loading, errorOnlinePayment } = this.state;

    return (
      <div>
        <Snackbar message={this.state.message} />
        {this.state.openModal && (
          <ModalMessage
            userMessage={this.state.msgSnackbar}
            titleMessage={this.state.titleMessage}
            setUserMessageHomeRead={this.closeModal}
            getUserMessageHomeChecked={() => {}}
            modalUserStatusAPI={true}
          />
        )}

        <Grid container className={classes.container}>
          <Grid item className={classes.gridItem}>
            <Typography
              variant="h6"
              component="h4"
              style={{
                fontSize: "2.15rem",
                display: "flex",
                justifyContent: "center",
              }}
              color="textSecondary"
            >
              <strong>PAGAMENTO ONLINE</strong>
            </Typography>
            <Typography variant="h6" component="h3" color="textSecondary" >
              <p style={{ textAlign: "justify" }}>
                Selecione o banco onde você deseja efetuar o seu pagamento. Após
                a seleção do banco de sua preferência, você será redirecionado
                para a página de transações em ambiente seguro do banco
                escolhido.
                <p>
                  O pagamento deverá ser efetuado em até 20 minutos após o
                  redirecionamento.
                </p>
                <p>
                  Você também receberá instruções de pagamento e deve inserir
                  seus dados de acordo com o que for solicitado.
                </p>
              </p>
            </Typography>
          </Grid>

          <Grid item xs={12} sm={8} md={7} className={classes.gridItem}>
            <div>
              <Grid container>
                {loading && (
                  <div className={classes.loadingDiv}>
                    <LoadingDefault typeLoading={"card"} />
                  </div>
                )}

                {banks === "Erro ao carregar os Bancos." && (
                  <ContentNotLoaded message={banks} />
                )}

                {banks.length === 0 && !loading && (
                  <ContentNotLoaded message={"Bancos não encontrados"} />
                )}

                {banks.length > 0 && (
                  <CardBankGroup
                    banks={banks}
                    typeCard={"onlinePayment"}
                    handleBankSelected={this.handleBankSelected}
                    staticLogoDam={false}
                  />
                )}
              </Grid>
            </div>
            {errorOnlinePayment && (
              <div className={classes.loadingDiv}>
                <ContentNotLoaded message={this.state.message} />
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  openModalDebit: state.cardDebitState.openModalDebitValue,
  debitsSelectedValue: state.cardDebitState.debitsSelectedValue,
  openBankInfos: state.cardDebitState.openBankInfos,
  paymentDateValue: state.cardDebitState.paymentDateValue,
  bankSelectedOnlinePayment: state.cardDebitState.bankSelectedOnlinePayment,
  }
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openSnackComp,
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(PaymentBank)
);
